import $ from 'cash-dom';

export default () => {
  const $contents = $('.js-box-content');
  const $images = $('.js-box-image');

  $contents.on('click', (e) => {
    const $this = $(e.currentTarget);
    const $image = $($this.data('image'));

    if (!$this.hasClass('is-active')) {
      $images.removeClass('is-active');
      $contents.removeClass('is-active');

      $this.addClass('is-active');
      $image.addClass('is-active');
    }
  });
};
